import * as React from 'react';
import {connect} from 'react-redux';

import {getChannelEnumFromValue} from 'nutshell-core/channels/helpers';
import {Collections} from 'nutshell-core/collections';
import type {CoreEntityType} from 'nutshell-core/types';

import {getSourceTypeFromValue} from 'shells/lead-sidebar/sources/helpers';
import {SourcePickerOptionLabel} from 'shells/lead-sidebar/sources/source-picker-option-label';
import {SelectPickerGeneric} from 'shells/select-picker-generic/select-picker-generic';
import type {Option, Options} from 'shells/select-picker-generic/types';

import type {NutshellState} from '../../../../store';

type OwnProps = {
    inputId?: string;
    value: string | null | undefined;
    entityType?: CoreEntityType;
    onChange: (newValue: Option) => void;
    onClear?: () => void;
    filterOption?: (arg1: Option) => boolean;
    isDisabled?: boolean;
    // @ts-expect-error
    collectionType: Collections.CollectionName | null | undefined;
    openMenuOnFocus?: boolean;
};
type StateProps = {
    collection: {
        [collectionModelId: string]: any;
    }; // Will be a Collections.CollectionModel
};
type Props = OwnProps & StateProps;

function mapStateToProps(state: NutshellState, ownProps: OwnProps): StateProps {
    return {
        collection: ownProps.collectionType
            ? Collections.getAllOfType(state, ownProps.collectionType)
            : {},
    };
}

export class CollectionPickerComponent extends React.PureComponent<Props> {
    render() {
        let collectionOptions: Options = Object.keys(this.props.collection).map((key) => ({
            label: this.props.collection[key].name,
            value: this.props.collection[key].id,
        }));

        let formatOptionLabel;
        let styles;

        if (this.props.collectionType === 'sources') {
            collectionOptions = Object.keys(this.props.collection).map((key) => ({
                label: this.props.collection[key].name,
                value: this.props.collection[key].id,
                type: getSourceTypeFromValue(this.props.collection[key].sourceType),
                channel: this.props.collection[key].channel
                    ? {
                          value: getChannelEnumFromValue(this.props.collection[key].channel.value),
                          title: this.props.collection[key].channel.display,
                      }
                    : null,
            }));

            formatOptionLabel = SourcePickerOptionLabel;

            styles = {
                // @ts-expect-error
                control: (base) => ({
                    ...base,
                    height: 'fit-content',
                }),
                // @ts-expect-error
                singleValue: (base) => ({
                    ...base,
                    position: 'relative',
                    transform: 'none',
                    translate: 'none',
                    top: 'initial',
                    padding: '8px',
                }),
            };
        } else if (this.props.collectionType === 'tags' && this.props.entityType) {
            collectionOptions = Object.keys(this.props.collection)
                .filter((key) => this.props.collection[key].tagType === this.props.entityType)
                .map((key) => ({
                    label: this.props.collection[key].name,
                    value: this.props.collection[key].id,
                }));
        }

        return (
            <SelectPickerGeneric
                inputId={this.props.inputId}
                // If the value isn't found, the find returns `undefined`, but we
                // want to clear out the value (e.g. when changing collections
                // in the assignee special case), so use `null` instead
                value={collectionOptions.find(({value}) => value === this.props.value) || null}
                maxMenuHeight={220}
                menuShouldScrollIntoView={true}
                options={collectionOptions}
                isDisabled={this.props.isDisabled}
                onChange={this.props.onChange}
                onClear={this.props.onClear}
                filterOption={this.props.filterOption}
                placeholder={this.getPlaceholderText()}
                openMenuOnFocus={this.props.openMenuOnFocus}
                formatOptionLabel={formatOptionLabel}
                styles={styles}
            />
        );
    }

    getPlaceholderText = () => {
        if (!this.props.collectionType) {
            return '-';
        }

        return `Select ${Collections.getSingularDisplayName(this.props.collectionType, {
            includeArticle: true,
        })}…`;
    };
}
// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps);
export const CollectionPicker = connector(CollectionPickerComponent);
